import React from "react";

import { formatNumber, getAdminVerificationYearlyDataYear } from "utils";

import { CTACard, Divider, PayoutInVerification, ProgressSteps, Typography } from "components";

const stepTextDict = {
  farm: {
    approved: "Farm approved",
    rejected: "Farm rejected",
    notVerified: "Verify farm",
    verifying: "Verify farm",
  },
  fields: {
    approved: "Fields approved",
    notVerified: "Verify fields",
    verifying: "Verify fields",
    rejected: "Fields rejected",
    partiallyApproved: "Fields partially appoved",
  },
  module: {
    approved: "{{name}} approved",
    notVerified: "Verify {{name}}",
    verifying: "Verify {{name}}",
    rejected: "{{name}} rejected",
    partiallyApproved: "{{name}} partially approved",
  },
};

const getCta = (hasPending, farmStatus, payoutApproved) => {
  if (payoutApproved) {
    return { icon: "tabler/lock-off", text: "Revert approval" };
  }

  if (farmStatus === "rejected") {
    return { icon: "klim/no-funding", text: "Reject payout" };
  }

  if (hasPending) {
    return { icon: "tabler/lock", text: "Payout verificaton" };
  }

  return { icon: "klim/funding", text: "Verify payout" };
};

export const VerificationProgressCard = ({
  payout,
  preVerificationPayout,
  credits,
  preVerificationCredits,
  farmStatus = {},
  fieldStatus = {},
  modules = [],
  onClick,
  onCtaClick,
  payoutApproved = false,
}) => {
  const steps = [
    {
      active: farmStatus === "verifying",
      rejected: farmStatus === "rejected",
      completed: farmStatus === "approved" || farmStatus === "partiallyApproved",
      text: stepTextDict.farm[farmStatus],
      onClick: () => onClick("farm"),
    },
    {
      active: fieldStatus === "verifying",
      rejected: fieldStatus === "rejected",
      completed: fieldStatus === "approved" || fieldStatus === "partiallyApproved",
      text: stepTextDict.fields[fieldStatus],
      onClick: () => onClick("fields"),
    },
    ...modules.map((m) => ({
      active: m.status === "verifying",
      rejected: m.status === "rejected",
      completed: m.status === "approved" || m.status === "partiallyApproved",
      text: stepTextDict.module[m.status]?.replace("{{name}}", m.name),
      onClick: () => onClick(m.module),
    })),
  ];

  // The cta should be enabled if all steps are approved or rejected
  const hasPending = steps.some((s) => s.active);
  const hasRejected = steps.some((s) => s.rejected);

  const { icon, text } = getCta(hasPending, farmStatus, payoutApproved);

  return (
    // NOTE: removed disabled for now to force payout approvals
    <CTACard disabled={hasPending && !hasRejected} onCtaClick={onCtaClick} ctaIcon={icon} ctaText={text} showCTA>
      <PayoutInVerification
        payout={payout}
        preVerificationPayout={preVerificationPayout}
        rejected={farmStatus === "rejected"}
        caption={`total ${getAdminVerificationYearlyDataYear()} payout`}
      />
      <ProgressSteps steps={steps} className="margin-top-100" />
      <Divider className="divider" />
      <div className="total-carbon-credits">
        <Typography variant="paragraph-m">total carbon credits</Typography>

        <div className="credits">
          {preVerificationCredits != null ? (
            <Typography variant="paragraph-m" className="rejected-total rejected margin-right-50">
              {formatNumber({ number: preVerificationCredits, decimalPlaces: 2 })}
            </Typography>
          ) : null}
          <Typography variant="paragraph-m" className={`${farmStatus === "rejected" ? "rejected" : ""}`}>
            {credits != null ? formatNumber({ number: credits, decimalPlaces: 2 }) : ""}
          </Typography>
        </div>
      </div>
    </CTACard>
  );
};
